import React from 'react';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';

export default function IntNumberFormatText(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            decimalSeparator=""
            thousandSeparator="."
            isNumericString={true}
            decimalScale={0}
            displayType={'text'}
        />
    );
};

IntNumberFormatText.propTypes = {
    inputRef: PropTypes.func,
    onChange: PropTypes.func,
};